import { render } from "./RaidBoss.vue?vue&type=template&id=8d5d007a&scoped=true"
import script from "./RaidBoss.vue?vue&type=script&lang=js"
export * from "./RaidBoss.vue?vue&type=script&lang=js"

import "./RaidBoss.vue?vue&type=style&index=0&id=8d5d007a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d5d007a"]])

export default __exports__